import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { SliderListStyle } from '@website-builder/widgets/slider/model/slider-list-style';
import { SliderStyle } from '@website-builder/widgets/slider/model/slider-style';
import { SliderItemStyle } from '@website-builder/widgets/slider/model/slider-item-style';
import { SliderImageStyle } from '@website-builder/widgets/slider/model/style-image-style';
import { SliderTitleStyle } from '@website-builder/widgets/slider/model/slider-title-style';
import { SliderButtonStyle } from '@website-builder/widgets/slider/model/slider-button-style';
import { SliderContentStyle } from '@website-builder/widgets/slider/model/slider-content-style';
import { SliderElement } from '@website-builder/widgets/slider/slider-element';
import { SliderSubtitleStyle } from '@website-builder/widgets/slider/model/slider-subtitle-style';
import { SliderConfig } from '@website-builder/widgets/slider/model/slider-config';
import { SliderNavigation } from '@website-builder/widgets/slider/model/slider-navigation';
import { SliderSlideNav } from '@website-builder/widgets/slider/model/slider-slide-nav';
import { SliderOverlay } from '@website-builder/widgets/slider/model/slider-overlay';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class SliderWidget extends BaseMultipleWidget<SliderElement, SliderStyle> {
  readonly type = BuilderElementType.Slider;
  name: string;
  elements = [
    new SliderElement('assets/images/builder/placeholders/cityview.png'),
    new SliderElement('assets/images/builder/placeholders/cityscape.png'),
    new SliderElement('assets/images/builder/placeholders/mountain.png'),
    new SliderElement('assets/images/builder/placeholders/mountain.png'),
    new SliderElement('assets/images/builder/placeholders/cityscape.png'),
  ];
  fixedWidthMode = true;
  minHeight: number = undefined;
  height: number = null;

  style = new SliderStyle();
  listStyle = new SliderListStyle();
  itemStyle = new SliderItemStyle();
  imageStyle = new SliderImageStyle();
  titleStyle = new SliderTitleStyle();
  buttonStyle = new SliderButtonStyle();
  contentStyle = new SliderContentStyle();
  subtitleStyle = new SliderSubtitleStyle();

  config = new SliderConfig();
  navigation = new SliderNavigation();
  slideNav = new SliderSlideNav();
  overlay = new SliderOverlay();

  static normalizeInPlace(widget: SliderWidget): SliderWidget {
    const pureWidget = new SliderWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.name = widget.name ?? pureWidget.name;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => SliderElement.normalizeInPlace(element));
    widget.fixedWidthMode = widget.fixedWidthMode ?? pureWidget.fixedWidthMode;
    widget.minHeight = widget.minHeight ?? pureWidget.minHeight;
    widget.height = widget.height ?? pureWidget.height;
    widget.config = widget.config ?? pureWidget.config;
    widget.navigation = widget.navigation ?? pureWidget.navigation;
    widget.slideNav = widget.slideNav ?? pureWidget.slideNav;
    widget.overlay = widget.overlay ?? pureWidget.overlay;

    widget.style = SliderStyle.normalize(widget.style);
    widget.listStyle = SliderListStyle.normalize(widget.listStyle);
    widget.itemStyle = SliderItemStyle.normalize(widget.itemStyle);
    widget.imageStyle = SliderImageStyle.normalize(widget.imageStyle);
    widget.titleStyle = SliderTitleStyle.normalize(widget.titleStyle);
    widget.buttonStyle = SliderButtonStyle.normalize(widget.buttonStyle);
    widget.contentStyle = SliderContentStyle.normalize(widget.contentStyle);
    widget.subtitleStyle = SliderSubtitleStyle.normalize(widget.subtitleStyle);

    return widget;
  }
}
